export default "__VITE_ASSET__B1oCiMc2__"